import React from 'react';
import PropTypes from 'prop-types';

import './NumberInput.css';

const NumberInput = ({ value, min, max, step, onChange }) => {
  const _onChange = (val, step) => {
    let parsedVal = parseFloat(val);
    if (!isNaN(parsedVal)) {
      val = parsedVal;
    }

    if (step) {
      val += step;
    }

    if (val > max) {
      return;
    }

    if (val < min) {
      return;
    }

    onChange(val);
  };

  return (
    <div name="NumberInput">
      <input
        type="number"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={e => _onChange(e.target.value)} />
      <button
        style={{ backgroundImage: 'url("images/arrow_up.svg")' }}
        onClick={() => _onChange(value, step)} />
      <button
        style={{ backgroundImage: 'url("images/arrow_down.svg")' }}
        onClick={() => _onChange(value, -step)} />
    </div>
  );
};

NumberInput.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  onChange: PropTypes.func,
};

NumberInput.defaultProps = {
  min: -Infinity,
  max: Infinity,
  step: 1
};

export default NumberInput;
